// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__39lMD","resetButton":"App_resetButton__3kIL2"};